import React, { useEffect, useRef } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import {Box, Typography} from "@mui/material";
import { mapStyles } from "./components/mapStyles";
import {useTranslation} from "react-i18next";
import {CircleDot} from "lucide-react";
import {Alert} from "@mui/lab";
import MapPin from "../../../../files/img/pins/pin50.png";
import UserPin from "../../../../files/img/pins/user50.png";
import CourierPin from "../../../../files/img/pins/courier50.png";
import VendorPin from "../../../../files/img/pins/store50.png";

const StaticMap = ({ coordinates = { lat: 41.0082, lng: 28.9784 }, height = 250, radiusKm , no_zoom = false,zoom= 11,pin = 'default' }) => {
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const circleRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        const loader = new Loader({
            apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
            libraries: ["places"],
        });

        loader.load().then(() => {
            const google = window.google;
            const map = new google.maps.Map(mapRef.current, {
                center: coordinates,
                zoom: zoom,
                disableDefaultUI: true,
                zoomControl: !no_zoom,
                styles: mapStyles,
                gestureHandling: "greedy",
            });

            // Create a marker at the given coordinates
            markerRef.current = new google.maps.Marker({
                position: coordinates,
                map: map,
                icon:pin === "default" ? MapPin : pin === "user" ? UserPin : CourierPin,

            });
            if(!!radiusKm){
                circleRef.current = new google.maps.Circle({
                    map: map,
                    center: coordinates,
                    radius: radiusKm * 1000, // Convert km to meters
                    fillColor: "rgba(255, 0, 0, 0.4)", // Light red fill with transparency
                    strokeColor: "#F0051F", // Red border
                    strokeWeight: 1,
                });

                // Adjust the map to fit the circle
                //map.fitBounds(circleRef.current.getBounds());
            }

        });
    }, [coordinates, radiusKm]);

    return (
        <>
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: `${height}px`,
                    borderRadius: 2,
                    overflow: "hidden",
                }}
            >
                <Box ref={mapRef} sx={{ width: "100%", height: "100%" }}></Box>
            </Box>
            {
                !!radiusKm &&
                <Alert icon={<CircleDot fontSize="inherit" />} severity="success" style={{marginTop:10,paddingTop:0,paddingBottom:0}}>
                    {t('radiusKmMeaning')}
                </Alert>
            }
        </>

    );
};

export default StaticMap;
